import { api } from "@/http/api-client"
import type { TGetDashboardResponse } from "./types-dashboard"

export function getDashboard(slug: string) {
  return api.get<TGetDashboardResponse>(`/organizations/${slug}/dashboard`)
}
